import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
const privacyContent = <>
    <h3 className="text-xl font-heading font-bold text-navy mb-4" data-id="element-76">
      1. Información que Recopilamos
    </h3>
    <p className="mb-4" data-id="element-77">
      Recopilamos información personal que usted nos proporciona directamente al
      realizar una compra, como su nombre, dirección de correo electrónico e
      información de pago. No recopilamos información de menores de edad
      directamente.
    </p>

    <h3 className="text-xl font-heading font-bold text-navy mb-4" data-id="element-78">
      2. Uso de la Información
    </h3>
    <p className="mb-4" data-id="element-79">
      Utilizamos su información personal para procesar su compra, enviarle el
      producto digital adquirido y comunicarnos con usted sobre su pedido. No
      vendemos ni compartimos su información personal con terceros para fines de
      marketing.
    </p>

    <h3 className="text-xl font-heading font-bold text-navy mb-4" data-id="element-80">
      3. Protección de Datos
    </h3>
    <p className="mb-4" data-id="element-81">
      Implementamos medidas de seguridad técnicas y organizativas para proteger
      su información personal contra el acceso no autorizado, la alteración,
      divulgación o destrucción.
    </p>

    <h3 className="text-xl font-heading font-bold text-navy mb-4" data-id="element-82">
      4. Cookies
    </h3>
    <p className="mb-4" data-id="element-83">
      Nuestro sitio web puede utilizar cookies para mejorar su experiencia de
      navegación y analizar el tráfico del sitio. Puede configurar su navegador
      para rechazar cookies.
    </p>

    <h3 className="text-xl font-heading font-bold text-navy mb-4" data-id="element-84">
      5. Sus Derechos
    </h3>
    <p className="mb-4" data-id="element-85">
      Usted tiene derecho a acceder, corregir o eliminar su información
      personal. También puede solicitar la portabilidad de sus datos o
      restringir su procesamiento.
    </p>

    <h3 className="text-xl font-heading font-bold text-navy mb-4" data-id="element-86">
      6. Cambios a esta Política
    </h3>
    <p data-id="element-87">
      Nos reservamos el derecho de actualizar esta política de privacidad en
      cualquier momento. Los cambios serán publicados en esta página con la
      fecha de la última actualización.
    </p>
  </>;
const termsContent = <>
    <h3 className="text-xl font-heading font-bold text-navy mb-4" data-id="element-88">
      1. Aceptación de los Términos
    </h3>
    <p className="mb-4" data-id="element-89">
      Al acceder y utilizar este sitio web y adquirir nuestros productos
      digitales, usted acepta estar sujeto a estos términos y condiciones de
      uso.
    </p>

    <h3 className="text-xl font-heading font-bold text-navy mb-4" data-id="element-90">
      2. Producto Digital
    </h3>
    <p className="mb-4" data-id="element-91">
      El Mini-CEO Blueprint es un producto digital descargable. Una vez
      completada la compra, recibirá acceso inmediato al contenido. El producto
      está diseñado como una guía educativa para padres e hijos.
    </p>

    <h3 className="text-xl font-heading font-bold text-navy mb-4" data-id="element-92">
      3. Uso Permitido
    </h3>
    <p className="mb-4" data-id="element-93">
      El contenido adquirido es para uso personal y familiar únicamente. Queda
      prohibida la reproducción, distribución o reventa del material sin
      autorización expresa por escrito.
    </p>

    <h3 className="text-xl font-heading font-bold text-navy mb-4" data-id="element-94">
      4. Responsabilidad
    </h3>
    <p className="mb-4" data-id="element-95">
      Los resultados pueden variar. No garantizamos ingresos específicos. El
      éxito depende de la aplicación individual del método. Los padres son
      responsables de supervisar las actividades de sus hijos en todo momento.
    </p>

    <h3 className="text-xl font-heading font-bold text-navy mb-4" data-id="element-96">
      5. Política de Reembolso
    </h3>
    <p className="mb-4" data-id="element-97">
      Debido a la naturaleza digital del producto, todas las ventas son finales.
      Si experimenta problemas técnicos para acceder al contenido, estaremos
      encantados de ayudarle.
    </p>

    <h3 className="text-xl font-heading font-bold text-navy mb-4" data-id="element-98">
      6. Propiedad Intelectual
    </h3>
    <p className="mb-4" data-id="element-99">
      Todo el contenido, incluyendo textos, gráficos, plantillas y metodologías,
      está protegido por derechos de autor y es propiedad exclusiva de Mini-CEO
      Blueprint.
    </p>

    <h3 className="text-xl font-heading font-bold text-navy mb-4" data-id="element-100">
      7. Ley Aplicable
    </h3>
    <p data-id="element-101">
      Estos términos se rigen por las leyes de los Estados Unidos de América.
      Cualquier disputa será resuelta en los tribunales competentes.
    </p>
  </>;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-navy-dark py-8 px-4" data-id="element-102">
        <div className="max-w-4xl mx-auto flex flex-col items-center gap-4" data-id="element-103">
          <div className="flex items-center gap-6" data-id="element-104">
            <button onClick={() => setActiveModal('privacy')} className="text-gray-400 hover:text-white text-sm font-body transition-colors" data-id="element-105">
              Política de Privacidad
            </button>
            <span className="text-gray-600" data-id="element-106">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-gray-400 hover:text-white text-sm font-body transition-colors" data-id="element-107">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-gray-500 text-sm font-body" data-id="element-108">
            © {new Date().getFullYear()} Mini-CEO Blueprint. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>

      {/* Modal */}
      <AnimatePresence data-id="element-109">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-110">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.2
        }} className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-111">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-gray-200" data-id="element-112">
                <h2 className="text-2xl font-heading font-bold text-navy" data-id="element-113">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h2>
                <button onClick={() => setActiveModal(null)} className="text-gray-400 hover:text-navy transition-colors p-1 rounded-lg hover:bg-gray-100" data-id="element-114">
                  <X className="w-6 h-6" data-id="element-115" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6 overflow-y-auto font-body text-gray-600 leading-relaxed" data-id="element-116">
                {activeModal === 'privacy' ? privacyContent : termsContent}
              </div>

              {/* Footer */}
              <div className="p-4 border-t border-gray-200 text-center" data-id="element-117">
                <button onClick={() => setActiveModal(null)} className="bg-navy text-white font-heading font-bold px-8 py-2.5 rounded-lg hover:bg-navy-light transition-colors text-sm" data-id="element-118">
                  Cerrar
                </button>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}